import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { getBookInfo } from '../modules/actions';
import { connect } from "react-redux";

class Schools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            slice: [],
            perPage: 10,
            currentPage: 0,
            editableRow: null,
            name: "",
            classno: 0,
            subject: "",
            id: ""
        }
        this.handlePageClick = this
            .handlePageClick
            .bind(this);
    }

    receivedData() {
        axios
            .get(`${BASEURL}/api/v1/school/fetchall`)
            .then(res => {
                console.log('res.data', res.data);
                const data = [];
                for (let i = res.data.length - 1; i >= 0; i--) {
                    data.push(res.data[i]);
                }
                // console.log('data', data);
                const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
                console.log('slice', slice);
                this.setState({
                    pageCount: Math.ceil(data.length / this.state.perPage),
                    slice
                })
            });
    }
    handlePageClick(e) {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;
        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.receivedData()
        });

    };

    componentDidMount() {
        this.receivedData()
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    // handleUpdateBook() {
    //     let data = {};
    //     data.id = this.state.id;
    //     data.name = this.state.name;
    //     data.classno = this.state.classno;
    //     data.subject = this.state.subject;

    //     // console.log('this.state.id', this.state.id)

    //     // console.log('update data', data)
    //     axios.put(`${BASEURL}/api/v1/books/update`, data)
    //         .then(res => {
    //             if (res.status === 200) {
    //                 console.log('res.data', res.data);
    //                 this.receivedData()
    //             }
    //         })
    //         .catch((err) => {
    //             console.log('Update book Error', err);
    //         })
    // }

    render() {
        return (

            <div id="wrapper">
                <Sidebar act="schools" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Schools" breadcrumbItems={["Test Generator", "Schools"]} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <NavLink to="addSchools" className="btn btn-primary brn-sm"><i className="mdi mdi-plus-circle" /> Add Schools</NavLink>

                                            <table className="table table-centered mb-0 mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Address</th>
                                                        <th>State</th>
                                                        <th>Username</th>
                                                        <th>Password</th>
                                                        <th>Status</th>
                                                        {/* <th>Actions</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.slice.map((data, idx) => (
                                                        <tr>
                                                            <td className="table-user">
                                                                {this.state.editableRow === idx ?
                                                                    <input type="text" id="name" className="form-control" onChange={(e) => this.handleChange(e)}
                                                                        name="name" placeholder="Enter School Name"
                                                                        defaultValue={data.name} disabled={this.state.editableRow !== idx} />
                                                                    :
                                                                    <input type="text" id="name" className="form-control" onChange={(e) => this.handleChange(e)}
                                                                        name="name" placeholder="Enter School Name"
                                                                        value={data.name} disabled={this.state.editableRow !== idx} />
                                                                }
                                                            </td>
                                                            <td className="table-user">
                                                                {this.state.editableRow === idx ?
                                                                    <input type="text" id="address" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="address" placeholder="Enter address" defaultValue={data.address} disabled={this.state.editableRow !== idx} />
                                                                    :
                                                                    <input type="text" id="address" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="address" placeholder="Enter address" value={data.address} disabled={this.state.editableRow !== idx} />
                                                                }
                                                            </td>
                                                            <td className="table-user">
                                                                {this.state.editableRow === idx ?
                                                                    <input type="text" id="state" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="state" placeholder="Enter state" defaultValue={data.state} disabled={this.state.editableRow !== idx} />
                                                                    :
                                                                    <input type="text" id="state" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="state" placeholder="Enter state" value={data.state} disabled={this.state.editableRow !== idx} />
                                                                }
                                                            </td>
                                                            <td className="table-user">
                                                                {this.state.editableRow === idx ?
                                                                    <input type="text" id="username" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="username" placeholder="Enter username" defaultValue={data.username} disabled={this.state.editableRow !== idx} />
                                                                    :
                                                                    <input type="text" id="username" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="username" placeholder="Enter username" value={data.username} disabled={this.state.editableRow !== idx} />
                                                                }
                                                            </td>
                                                            <td className="table-user">
                                                                {this.state.editableRow === idx ?
                                                                    <input type="text" id="password" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="password" placeholder="Enter password" defaultValue={data.password} disabled={this.state.editableRow !== idx} />
                                                                    :
                                                                    <input type="text" id="password" className="form-control"
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        name="password" placeholder="Enter password" value={data.password} disabled={this.state.editableRow !== idx} />
                                                                }
                                                            </td>
                                                            <td className="table-user">
                                                                <p>{data.status ? 'Active' : 'Inactive'}</p>
                                                            </td>
                                                            {/* <td >
                                                                {this.state.editableRow === idx ?
                                                                    <button className="btn btn-primary brn-sm table_Action_btns"
                                                                        onClick={() => { this.setState({ editableRow: null }); }}>
                                                                        <i className="mdi mdi-content-save-outline" />save</button> :
                                                                    <button className="btn mb-2"
                                                                        onClick={() => { this.setState({ editableRow: idx }) }}>
                                                                        <i className="mdi mdi-pencil" /></button>
                                                                }
                                                                <NavLink to="#" className="btn mb-2"> <i className="mdi mdi-delete-outline" /></NavLink>
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            <div className="pagination-div">
                                                <ReactPaginate
                                                    previousLabel={"Previous"}
                                                    nextLabel={"Next"}
                                                    breakLabel={"..."}
                                                    breakClassName={"break-me"}
                                                    pageCount={this.state.pageCount}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={this.handlePageClick}
                                                    containerClassName={"pagination"}
                                                    subContainerClassName={"pages pagination"}
                                                    activeClassName={"active"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>

            </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({
    getBook: (bid) => dispatch(getBookInfo(bid)),
});

export default connect(null, mapDispatchToProps)(Schools);